// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"f1d97","circle":"_818f8","rounded":"_956a4","square":"_23ccd","red":"_8125c","orange":"ff482","yellow":"_09496","green":"_03d16","blue":"e0a34","transparent":"ad8c8"};